import { useEffect, useState } from "react";
import { isHeld, subscribeHold } from "utils/playbackHold";

/**
 * Is anything allowed to advance time right now?
 *
 * EVERY medium that moves the lecture forward must read this — the original's waveform and the
 * video both. The video used not to: it obeyed `state.playing` alone, so while a voicing was being
 * waited for the picture ran on, and because nothing ever seeked it back, each wait became a
 * permanent offset that accumulated over the lecture. One hook, so a third medium cannot be added
 * later and quietly miss the gate.
 */
export const usePlaybackGate = (): boolean => {
    const [held, setHeld] = useState<boolean>(isHeld);
    useEffect(() => subscribeHold(setHeld), []);
    return held;
};
